// Declaration order is the admin dropdown's render order (TimeIncrementsSection maps
// Object.values over this enum), so members are listed by ascending duration. The literals
// name fractions of an hour; the labels below are what users actually read.
export enum Granularity {
	Minutes = 'MINUTES',
	Twelfths = 'TWELFTHS',
	Tenths = 'TENTHS',
	Sixths = 'SIXTHS',
	Quarters = 'QUARTERS',
	Halves = 'HALVES',
	Hours = 'HOURS',
	Days = 'DAYS',
}

export function getLabelFromGranularity(granularity: Granularity): string {
	switch (granularity) {
		case Granularity.Minutes:
			return '1 minute';
		case Granularity.Twelfths:
			return '5 minutes';
		case Granularity.Tenths:
			return '6 minutes';
		case Granularity.Sixths:
			return '10 minutes';
		case Granularity.Quarters:
			return '15 minutes';
		case Granularity.Halves:
			return '30 minutes';
		case Granularity.Hours:
			return '1 hour';
		case Granularity.Days:
			return '1 day';
	}
}

export function getShortLabelFromGranularity(granularity: Granularity): string {
	switch (granularity) {
		case Granularity.Minutes:
			return 'minute';
		case Granularity.Twelfths:
			return '5 minutes';
		case Granularity.Tenths:
			return 'tenth of an hour';
		case Granularity.Sixths:
			return '10 minutes';
		case Granularity.Quarters:
			return 'quarter';
		case Granularity.Halves:
			return '30 minutes';
		case Granularity.Hours:
			return 'hour';
		case Granularity.Days:
			return 'day';
	}
}

export function getGranularityInfoLabel(granularity: Granularity): string {
	const labelStart = 'Time entries round up to ';
	switch (granularity) {
		case Granularity.Minutes:
			return labelStart + 'the next minute';
		case Granularity.Twelfths:
			return labelStart + 'the next 5 minutes';
		case Granularity.Tenths:
			return labelStart + 'the next tenth of an hour';
		case Granularity.Sixths:
			return labelStart + 'the next 10 minutes';
		case Granularity.Quarters:
			return labelStart + 'the next quarter';
		case Granularity.Halves:
			return labelStart + 'the next 30 minutes';
		case Granularity.Hours:
			return labelStart + 'the next hour';
		case Granularity.Days:
			return labelStart + 'match your working hours';
	}
}
